var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    "class": {
      'client-action-handler': _vm.actionButton
    }
  }, [_vm.iconButton ? _c('div', {
    staticClass: "d-flex flex-column align-items-center bl-color w-inline-block no-decoration pointer",
    on: {
      "click": function click($event) {
        return _vm.openClientPersonalInfoPopup();
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "edit",
      "size": 22
    }
  }), _vm._v(" upraviť ")], 1) : _c('div', {
    staticClass: "div-block-25"
  }, [_c('div', {
    staticClass: "add-prijem-btn",
    "class": {
      'client-action-button': _vm.actionButton
    },
    attrs: {
      "data-w-id": "239b29db-b0c5-1e0a-548a-17a023868560",
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function click($event) {
        return _vm.openClientPersonalInfoPopup();
      },
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter") && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
        $event.preventDefault();
        return _vm.openClientPersonalInfoPopup();
      }
    }
  }, [_c('div', {
    staticClass: "text-small bl-color pointer",
    "class": {
      'client-action-label': _vm.actionButton
    }
  }, [_vm._v(" " + _vm._s(_vm.actionLabel || 'upraviť ÚDAJE A BONITU') + " ")])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }